"use strict";
exports["-575021c8"] = validate10;
const schema11 = {"$schema":"http://json-schema.org/draft-07/schema","type":"object","title":"WizEWSAccessTitle","properties":{"emailAddress":{"type":"string","title":"LabelTargetMailboxEmailAddress","pattern":"^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$"},"authenticationType":{"type":"string","title":"LabelAuthenticationType","default":"Basic","enum":["OAuth","Basic"],"enumNames":["AuthenticationTypeOAuth","AuthenticationTypeBasic"]},"useAutodiscover":{"type":"boolean","title":"LabelAutodiscoverGroup","default":true,"enum":[true,false],"enumNames":["LabelUseAutodiscoverRadio","LabelSpecifyWebServiceUrlRadio"]},"useWellKnownFolder":{"type":"boolean","title":"LabelFolderSelection","default":true,"enum":[true,false],"enumNames":["LabelUseFolderConstant","LabelSpecifyFolderId"]},"useImpersonation":{"type":"boolean","title":"LabelUseImpersonation","default":false},"ignoreTrustForSsl":{"type":"boolean","title":"LabelIgnoreTrustForSsl","default":false},"notice":{"type":"object","title":"PanelTitle_Notice","properties":{"testAccountConsent":{"type":"boolean","title":"TestAccountConsent","description":"NoticeDescription"}},"required":["testAccountConsent"]},"proofOfWork":{"type":"string","title":""}},"required":["emailAddress","authenticationType","useAutodiscover","useWellKnownFolder","notice","proofOfWork"],"dependencies":{"authenticationType":{"oneOf":[{"properties":{"authenticationType":{"enum":["OAuth"]},"oAuthCredential":{"type":"object","title":"OAuthCredentialsLabel"}},"required":["oAuthCredential"]},{"properties":{"authenticationType":{"enum":["Basic"]},"basicAuthNotice":{"type":"object","title":"","properties":{},"required":[]},"userName":{"type":"string","title":"LabelServiceAccountUserName","pattern":"^.+\\\\.+$|^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$"},"password":{"type":"string","title":"LabelPassword"}},"required":["basicAuthNotice","userName","password"]}]},"useAutodiscover":{"oneOf":[{"properties":{"useAutodiscover":{"enum":[false]},"ewsHostName":{"type":"string","title":"LabelEwsHostName","pattern":"^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$"}},"required":["ewsHostName"]},{"properties":{"useAutodiscover":{"enum":[true]}}}]},"useWellKnownFolder":{"oneOf":[{"properties":{"useWellKnownFolder":{"enum":[true]},"wellKnownFolder":{"type":"string","title":"LabelEwsFolderType","default":"Inbox","enum":["Calendar","Contacts","DeletedItems","Drafts","Inbox","Journal","JunkEmail","MsgFolderRoot","Notes","Outbox","PublicFoldersRoot","Root","SearchFolders","SentItems","Tasks","VoiceMail"]}},"required":["wellKnownFolder"]},{"properties":{"useWellKnownFolder":{"enum":[false]},"folderId":{"type":"string","title":"LabelEwsFolderId","pattern":"^[-A-Za-z0-9+/=]|=[^=]|={3,}$"}},"required":["folderId"]}]},"useImpersonation":{"oneOf":[{"properties":{"useImpersonation":{"enum":[true]},"impersonatedUser":{"type":"string","title":"LabelImpersonatedUser","pattern":"^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$|^S-\\d-\\d+-(\\d+-){1,14}\\d+$"},"impersonatedUserIdentifier":{"type":"string","title":"LabelImpersonatedIdentifier","default":"SmtpAddress","enum":["SmtpAddress","PrincipalName","SID"]}},"required":["impersonatedUser","impersonatedUserIdentifier"]},{"properties":{"useImpersonation":{"enum":[false]}}}]}},"$id":"-575021c8"};
const pattern0 = new RegExp("^.+\\\\.+$|^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$", "u");
const pattern1 = new RegExp("^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$", "u");
const pattern2 = new RegExp("^[-A-Za-z0-9+/=]|=[^=]|={3,}$", "u");
const pattern3 = new RegExp("^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$|^S-\\d-\\d+-(\\d+-){1,14}\\d+$", "u");
const pattern4 = new RegExp("^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$", "u");

function validate10(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="-575021c8" */;
let vErrors = null;
let errors = 0;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.emailAddress === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "emailAddress"},message:"must have required property '"+"emailAddress"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.authenticationType === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "authenticationType"},message:"must have required property '"+"authenticationType"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.useAutodiscover === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "useAutodiscover"},message:"must have required property '"+"useAutodiscover"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.useWellKnownFolder === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "useWellKnownFolder"},message:"must have required property '"+"useWellKnownFolder"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.notice === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "notice"},message:"must have required property '"+"notice"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.proofOfWork === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "proofOfWork"},message:"must have required property '"+"proofOfWork"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.authenticationType !== undefined){
const _errs2 = errors;
let valid1 = false;
let passing0 = null;
const _errs3 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.oAuthCredential === undefined){
const err6 = {instancePath,schemaPath:"#/dependencies/authenticationType/oneOf/0/required",keyword:"required",params:{missingProperty: "oAuthCredential"},message:"must have required property '"+"oAuthCredential"+"'",schema:schema11.dependencies.authenticationType.oneOf[0].required,parentSchema:schema11.dependencies.authenticationType.oneOf[0],data};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.authenticationType !== undefined){
let data0 = data.authenticationType;
if(!(data0 === "OAuth")){
const err7 = {instancePath:instancePath+"/authenticationType",schemaPath:"#/dependencies/authenticationType/oneOf/0/properties/authenticationType/enum",keyword:"enum",params:{allowedValues: schema11.dependencies.authenticationType.oneOf[0].properties.authenticationType.enum},message:"must be equal to one of the allowed values",schema:schema11.dependencies.authenticationType.oneOf[0].properties.authenticationType.enum,parentSchema:schema11.dependencies.authenticationType.oneOf[0].properties.authenticationType,data:data0};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.oAuthCredential !== undefined){
let data1 = data.oAuthCredential;
if(!(data1 && typeof data1 == "object" && !Array.isArray(data1))){
const err8 = {instancePath:instancePath+"/oAuthCredential",schemaPath:"#/dependencies/authenticationType/oneOf/0/properties/oAuthCredential/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema11.dependencies.authenticationType.oneOf[0].properties.oAuthCredential.type,parentSchema:schema11.dependencies.authenticationType.oneOf[0].properties.oAuthCredential,data:data1};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
}
var _valid0 = _errs3 === errors;
if(_valid0){
valid1 = true;
passing0 = 0;
}
const _errs7 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.basicAuthNotice === undefined){
const err9 = {instancePath,schemaPath:"#/dependencies/authenticationType/oneOf/1/required",keyword:"required",params:{missingProperty: "basicAuthNotice"},message:"must have required property '"+"basicAuthNotice"+"'",schema:schema11.dependencies.authenticationType.oneOf[1].required,parentSchema:schema11.dependencies.authenticationType.oneOf[1],data};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(data.userName === undefined){
const err10 = {instancePath,schemaPath:"#/dependencies/authenticationType/oneOf/1/required",keyword:"required",params:{missingProperty: "userName"},message:"must have required property '"+"userName"+"'",schema:schema11.dependencies.authenticationType.oneOf[1].required,parentSchema:schema11.dependencies.authenticationType.oneOf[1],data};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(data.password === undefined){
const err11 = {instancePath,schemaPath:"#/dependencies/authenticationType/oneOf/1/required",keyword:"required",params:{missingProperty: "password"},message:"must have required property '"+"password"+"'",schema:schema11.dependencies.authenticationType.oneOf[1].required,parentSchema:schema11.dependencies.authenticationType.oneOf[1],data};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(data.authenticationType !== undefined){
let data2 = data.authenticationType;
if(!(data2 === "Basic")){
const err12 = {instancePath:instancePath+"/authenticationType",schemaPath:"#/dependencies/authenticationType/oneOf/1/properties/authenticationType/enum",keyword:"enum",params:{allowedValues: schema11.dependencies.authenticationType.oneOf[1].properties.authenticationType.enum},message:"must be equal to one of the allowed values",schema:schema11.dependencies.authenticationType.oneOf[1].properties.authenticationType.enum,parentSchema:schema11.dependencies.authenticationType.oneOf[1].properties.authenticationType,data:data2};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.basicAuthNotice !== undefined){
let data3 = data.basicAuthNotice;
if(!(data3 && typeof data3 == "object" && !Array.isArray(data3))){
const err13 = {instancePath:instancePath+"/basicAuthNotice",schemaPath:"#/dependencies/authenticationType/oneOf/1/properties/basicAuthNotice/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema11.dependencies.authenticationType.oneOf[1].properties.basicAuthNotice.type,parentSchema:schema11.dependencies.authenticationType.oneOf[1].properties.basicAuthNotice,data:data3};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.userName !== undefined){
let data4 = data.userName;
if(typeof data4 === "string"){
if(!pattern0.test(data4)){
const err14 = {instancePath:instancePath+"/userName",schemaPath:"#/dependencies/authenticationType/oneOf/1/properties/userName/pattern",keyword:"pattern",params:{pattern: "^.+\\\\.+$|^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$"},message:"must match pattern \""+"^.+\\\\.+$|^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$"+"\"",schema:"^.+\\\\.+$|^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$",parentSchema:schema11.dependencies.authenticationType.oneOf[1].properties.userName,data:data4};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
else {
const err15 = {instancePath:instancePath+"/userName",schemaPath:"#/dependencies/authenticationType/oneOf/1/properties/userName/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.dependencies.authenticationType.oneOf[1].properties.userName.type,parentSchema:schema11.dependencies.authenticationType.oneOf[1].properties.userName,data:data4};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.password !== undefined){
let data5 = data.password;
if(typeof data5 !== "string"){
const err16 = {instancePath:instancePath+"/password",schemaPath:"#/dependencies/authenticationType/oneOf/1/properties/password/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.dependencies.authenticationType.oneOf[1].properties.password.type,parentSchema:schema11.dependencies.authenticationType.oneOf[1].properties.password,data:data5};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
}
var _valid0 = _errs7 === errors;
if(_valid0 && valid1){
valid1 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid1 = true;
passing0 = 1;
}
}
if(!valid1){
const err17 = {instancePath,schemaPath:"#/dependencies/authenticationType/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf",schema:schema11.dependencies.authenticationType.oneOf,parentSchema:schema11.dependencies.authenticationType,data};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
else {
errors = _errs2;
if(vErrors !== null){
if(_errs2){
vErrors.length = _errs2;
}
else {
vErrors = null;
}
}
}
}
if(data.useAutodiscover !== undefined){
const _errs16 = errors;
let valid4 = false;
let passing1 = null;
const _errs17 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.ewsHostName === undefined){
const err18 = {instancePath,schemaPath:"#/dependencies/useAutodiscover/oneOf/0/required",keyword:"required",params:{missingProperty: "ewsHostName"},message:"must have required property '"+"ewsHostName"+"'",schema:schema11.dependencies.useAutodiscover.oneOf[0].required,parentSchema:schema11.dependencies.useAutodiscover.oneOf[0],data};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
if(data.useAutodiscover !== undefined){
let data6 = data.useAutodiscover;
if(!(data6 === false)){
const err19 = {instancePath:instancePath+"/useAutodiscover",schemaPath:"#/dependencies/useAutodiscover/oneOf/0/properties/useAutodiscover/enum",keyword:"enum",params:{allowedValues: schema11.dependencies.useAutodiscover.oneOf[0].properties.useAutodiscover.enum},message:"must be equal to one of the allowed values",schema:schema11.dependencies.useAutodiscover.oneOf[0].properties.useAutodiscover.enum,parentSchema:schema11.dependencies.useAutodiscover.oneOf[0].properties.useAutodiscover,data:data6};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
if(data.ewsHostName !== undefined){
let data7 = data.ewsHostName;
if(typeof data7 === "string"){
if(!pattern1.test(data7)){
const err20 = {instancePath:instancePath+"/ewsHostName",schemaPath:"#/dependencies/useAutodiscover/oneOf/0/properties/ewsHostName/pattern",keyword:"pattern",params:{pattern: "^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$"},message:"must match pattern \""+"^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$"+"\"",schema:"^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$",parentSchema:schema11.dependencies.useAutodiscover.oneOf[0].properties.ewsHostName,data:data7};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
else {
const err21 = {instancePath:instancePath+"/ewsHostName",schemaPath:"#/dependencies/useAutodiscover/oneOf/0/properties/ewsHostName/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.dependencies.useAutodiscover.oneOf[0].properties.ewsHostName.type,parentSchema:schema11.dependencies.useAutodiscover.oneOf[0].properties.ewsHostName,data:data7};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
}
var _valid1 = _errs17 === errors;
if(_valid1){
valid4 = true;
passing1 = 0;
}
const _errs21 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.useAutodiscover !== undefined){
let data8 = data.useAutodiscover;
if(!(data8 === true)){
const err22 = {instancePath:instancePath+"/useAutodiscover",schemaPath:"#/dependencies/useAutodiscover/oneOf/1/properties/useAutodiscover/enum",keyword:"enum",params:{allowedValues: schema11.dependencies.useAutodiscover.oneOf[1].properties.useAutodiscover.enum},message:"must be equal to one of the allowed values",schema:schema11.dependencies.useAutodiscover.oneOf[1].properties.useAutodiscover.enum,parentSchema:schema11.dependencies.useAutodiscover.oneOf[1].properties.useAutodiscover,data:data8};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
}
var _valid1 = _errs21 === errors;
if(_valid1 && valid4){
valid4 = false;
passing1 = [passing1, 1];
}
else {
if(_valid1){
valid4 = true;
passing1 = 1;
}
}
if(!valid4){
const err23 = {instancePath,schemaPath:"#/dependencies/useAutodiscover/oneOf",keyword:"oneOf",params:{passingSchemas: passing1},message:"must match exactly one schema in oneOf",schema:schema11.dependencies.useAutodiscover.oneOf,parentSchema:schema11.dependencies.useAutodiscover,data};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
else {
errors = _errs16;
if(vErrors !== null){
if(_errs16){
vErrors.length = _errs16;
}
else {
vErrors = null;
}
}
}
}
if(data.useWellKnownFolder !== undefined){
const _errs24 = errors;
let valid7 = false;
let passing2 = null;
const _errs25 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.wellKnownFolder === undefined){
const err24 = {instancePath,schemaPath:"#/dependencies/useWellKnownFolder/oneOf/0/required",keyword:"required",params:{missingProperty: "wellKnownFolder"},message:"must have required property '"+"wellKnownFolder"+"'",schema:schema11.dependencies.useWellKnownFolder.oneOf[0].required,parentSchema:schema11.dependencies.useWellKnownFolder.oneOf[0],data};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
if(data.useWellKnownFolder !== undefined){
let data9 = data.useWellKnownFolder;
if(!(data9 === true)){
const err25 = {instancePath:instancePath+"/useWellKnownFolder",schemaPath:"#/dependencies/useWellKnownFolder/oneOf/0/properties/useWellKnownFolder/enum",keyword:"enum",params:{allowedValues: schema11.dependencies.useWellKnownFolder.oneOf[0].properties.useWellKnownFolder.enum},message:"must be equal to one of the allowed values",schema:schema11.dependencies.useWellKnownFolder.oneOf[0].properties.useWellKnownFolder.enum,parentSchema:schema11.dependencies.useWellKnownFolder.oneOf[0].properties.useWellKnownFolder,data:data9};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
if(data.wellKnownFolder !== undefined){
let data10 = data.wellKnownFolder;
if(typeof data10 !== "string"){
const err26 = {instancePath:instancePath+"/wellKnownFolder",schemaPath:"#/dependencies/useWellKnownFolder/oneOf/0/properties/wellKnownFolder/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.dependencies.useWellKnownFolder.oneOf[0].properties.wellKnownFolder.type,parentSchema:schema11.dependencies.useWellKnownFolder.oneOf[0].properties.wellKnownFolder,data:data10};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
if(!((((((((((((((((data10 === "Calendar") || (data10 === "Contacts")) || (data10 === "DeletedItems")) || (data10 === "Drafts")) || (data10 === "Inbox")) || (data10 === "Journal")) || (data10 === "JunkEmail")) || (data10 === "MsgFolderRoot")) || (data10 === "Notes")) || (data10 === "Outbox")) || (data10 === "PublicFoldersRoot")) || (data10 === "Root")) || (data10 === "SearchFolders")) || (data10 === "SentItems")) || (data10 === "Tasks")) || (data10 === "VoiceMail"))){
const err27 = {instancePath:instancePath+"/wellKnownFolder",schemaPath:"#/dependencies/useWellKnownFolder/oneOf/0/properties/wellKnownFolder/enum",keyword:"enum",params:{allowedValues: schema11.dependencies.useWellKnownFolder.oneOf[0].properties.wellKnownFolder.enum},message:"must be equal to one of the allowed values",schema:schema11.dependencies.useWellKnownFolder.oneOf[0].properties.wellKnownFolder.enum,parentSchema:schema11.dependencies.useWellKnownFolder.oneOf[0].properties.wellKnownFolder,data:data10};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
}
var _valid2 = _errs25 === errors;
if(_valid2){
valid7 = true;
passing2 = 0;
}
const _errs29 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.folderId === undefined){
const err28 = {instancePath,schemaPath:"#/dependencies/useWellKnownFolder/oneOf/1/required",keyword:"required",params:{missingProperty: "folderId"},message:"must have required property '"+"folderId"+"'",schema:schema11.dependencies.useWellKnownFolder.oneOf[1].required,parentSchema:schema11.dependencies.useWellKnownFolder.oneOf[1],data};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
if(data.useWellKnownFolder !== undefined){
let data11 = data.useWellKnownFolder;
if(!(data11 === false)){
const err29 = {instancePath:instancePath+"/useWellKnownFolder",schemaPath:"#/dependencies/useWellKnownFolder/oneOf/1/properties/useWellKnownFolder/enum",keyword:"enum",params:{allowedValues: schema11.dependencies.useWellKnownFolder.oneOf[1].properties.useWellKnownFolder.enum},message:"must be equal to one of the allowed values",schema:schema11.dependencies.useWellKnownFolder.oneOf[1].properties.useWellKnownFolder.enum,parentSchema:schema11.dependencies.useWellKnownFolder.oneOf[1].properties.useWellKnownFolder,data:data11};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
if(data.folderId !== undefined){
let data12 = data.folderId;
if(typeof data12 === "string"){
if(!pattern2.test(data12)){
const err30 = {instancePath:instancePath+"/folderId",schemaPath:"#/dependencies/useWellKnownFolder/oneOf/1/properties/folderId/pattern",keyword:"pattern",params:{pattern: "^[-A-Za-z0-9+/=]|=[^=]|={3,}$"},message:"must match pattern \""+"^[-A-Za-z0-9+/=]|=[^=]|={3,}$"+"\"",schema:"^[-A-Za-z0-9+/=]|=[^=]|={3,}$",parentSchema:schema11.dependencies.useWellKnownFolder.oneOf[1].properties.folderId,data:data12};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
}
else {
const err31 = {instancePath:instancePath+"/folderId",schemaPath:"#/dependencies/useWellKnownFolder/oneOf/1/properties/folderId/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.dependencies.useWellKnownFolder.oneOf[1].properties.folderId.type,parentSchema:schema11.dependencies.useWellKnownFolder.oneOf[1].properties.folderId,data:data12};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
}
}
var _valid2 = _errs29 === errors;
if(_valid2 && valid7){
valid7 = false;
passing2 = [passing2, 1];
}
else {
if(_valid2){
valid7 = true;
passing2 = 1;
}
}
if(!valid7){
const err32 = {instancePath,schemaPath:"#/dependencies/useWellKnownFolder/oneOf",keyword:"oneOf",params:{passingSchemas: passing2},message:"must match exactly one schema in oneOf",schema:schema11.dependencies.useWellKnownFolder.oneOf,parentSchema:schema11.dependencies.useWellKnownFolder,data};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
else {
errors = _errs24;
if(vErrors !== null){
if(_errs24){
vErrors.length = _errs24;
}
else {
vErrors = null;
}
}
}
}
if(data.useImpersonation !== undefined){
const _errs34 = errors;
let valid10 = false;
let passing3 = null;
const _errs35 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.impersonatedUser === undefined){
const err33 = {instancePath,schemaPath:"#/dependencies/useImpersonation/oneOf/0/required",keyword:"required",params:{missingProperty: "impersonatedUser"},message:"must have required property '"+"impersonatedUser"+"'",schema:schema11.dependencies.useImpersonation.oneOf[0].required,parentSchema:schema11.dependencies.useImpersonation.oneOf[0],data};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
if(data.impersonatedUserIdentifier === undefined){
const err34 = {instancePath,schemaPath:"#/dependencies/useImpersonation/oneOf/0/required",keyword:"required",params:{missingProperty: "impersonatedUserIdentifier"},message:"must have required property '"+"impersonatedUserIdentifier"+"'",schema:schema11.dependencies.useImpersonation.oneOf[0].required,parentSchema:schema11.dependencies.useImpersonation.oneOf[0],data};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
if(data.useImpersonation !== undefined){
let data13 = data.useImpersonation;
if(!(data13 === true)){
const err35 = {instancePath:instancePath+"/useImpersonation",schemaPath:"#/dependencies/useImpersonation/oneOf/0/properties/useImpersonation/enum",keyword:"enum",params:{allowedValues: schema11.dependencies.useImpersonation.oneOf[0].properties.useImpersonation.enum},message:"must be equal to one of the allowed values",schema:schema11.dependencies.useImpersonation.oneOf[0].properties.useImpersonation.enum,parentSchema:schema11.dependencies.useImpersonation.oneOf[0].properties.useImpersonation,data:data13};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
}
if(data.impersonatedUser !== undefined){
let data14 = data.impersonatedUser;
if(typeof data14 === "string"){
if(!pattern3.test(data14)){
const err36 = {instancePath:instancePath+"/impersonatedUser",schemaPath:"#/dependencies/useImpersonation/oneOf/0/properties/impersonatedUser/pattern",keyword:"pattern",params:{pattern: "^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$|^S-\\d-\\d+-(\\d+-){1,14}\\d+$"},message:"must match pattern \""+"^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$|^S-\\d-\\d+-(\\d+-){1,14}\\d+$"+"\"",schema:"^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$|^S-\\d-\\d+-(\\d+-){1,14}\\d+$",parentSchema:schema11.dependencies.useImpersonation.oneOf[0].properties.impersonatedUser,data:data14};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
}
else {
const err37 = {instancePath:instancePath+"/impersonatedUser",schemaPath:"#/dependencies/useImpersonation/oneOf/0/properties/impersonatedUser/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.dependencies.useImpersonation.oneOf[0].properties.impersonatedUser.type,parentSchema:schema11.dependencies.useImpersonation.oneOf[0].properties.impersonatedUser,data:data14};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
}
if(data.impersonatedUserIdentifier !== undefined){
let data15 = data.impersonatedUserIdentifier;
if(typeof data15 !== "string"){
const err38 = {instancePath:instancePath+"/impersonatedUserIdentifier",schemaPath:"#/dependencies/useImpersonation/oneOf/0/properties/impersonatedUserIdentifier/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.dependencies.useImpersonation.oneOf[0].properties.impersonatedUserIdentifier.type,parentSchema:schema11.dependencies.useImpersonation.oneOf[0].properties.impersonatedUserIdentifier,data:data15};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
if(!(((data15 === "SmtpAddress") || (data15 === "PrincipalName")) || (data15 === "SID"))){
const err39 = {instancePath:instancePath+"/impersonatedUserIdentifier",schemaPath:"#/dependencies/useImpersonation/oneOf/0/properties/impersonatedUserIdentifier/enum",keyword:"enum",params:{allowedValues: schema11.dependencies.useImpersonation.oneOf[0].properties.impersonatedUserIdentifier.enum},message:"must be equal to one of the allowed values",schema:schema11.dependencies.useImpersonation.oneOf[0].properties.impersonatedUserIdentifier.enum,parentSchema:schema11.dependencies.useImpersonation.oneOf[0].properties.impersonatedUserIdentifier,data:data15};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
}
}
var _valid3 = _errs35 === errors;
if(_valid3){
valid10 = true;
passing3 = 0;
}
const _errs41 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.useImpersonation !== undefined){
let data16 = data.useImpersonation;
if(!(data16 === false)){
const err40 = {instancePath:instancePath+"/useImpersonation",schemaPath:"#/dependencies/useImpersonation/oneOf/1/properties/useImpersonation/enum",keyword:"enum",params:{allowedValues: schema11.dependencies.useImpersonation.oneOf[1].properties.useImpersonation.enum},message:"must be equal to one of the allowed values",schema:schema11.dependencies.useImpersonation.oneOf[1].properties.useImpersonation.enum,parentSchema:schema11.dependencies.useImpersonation.oneOf[1].properties.useImpersonation,data:data16};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
}
}
var _valid3 = _errs41 === errors;
if(_valid3 && valid10){
valid10 = false;
passing3 = [passing3, 1];
}
else {
if(_valid3){
valid10 = true;
passing3 = 1;
}
}
if(!valid10){
const err41 = {instancePath,schemaPath:"#/dependencies/useImpersonation/oneOf",keyword:"oneOf",params:{passingSchemas: passing3},message:"must match exactly one schema in oneOf",schema:schema11.dependencies.useImpersonation.oneOf,parentSchema:schema11.dependencies.useImpersonation,data};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
else {
errors = _errs34;
if(vErrors !== null){
if(_errs34){
vErrors.length = _errs34;
}
else {
vErrors = null;
}
}
}
}
if(data.emailAddress !== undefined){
let data17 = data.emailAddress;
if(typeof data17 === "string"){
if(!pattern4.test(data17)){
const err42 = {instancePath:instancePath+"/emailAddress",schemaPath:"#/properties/emailAddress/pattern",keyword:"pattern",params:{pattern: "^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$"},message:"must match pattern \""+"^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$"+"\"",schema:"^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$",parentSchema:schema11.properties.emailAddress,data:data17};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
}
else {
const err43 = {instancePath:instancePath+"/emailAddress",schemaPath:"#/properties/emailAddress/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.emailAddress.type,parentSchema:schema11.properties.emailAddress,data:data17};
if(vErrors === null){
vErrors = [err43];
}
else {
vErrors.push(err43);
}
errors++;
}
}
if(data.authenticationType !== undefined){
let data18 = data.authenticationType;
if(typeof data18 !== "string"){
const err44 = {instancePath:instancePath+"/authenticationType",schemaPath:"#/properties/authenticationType/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.authenticationType.type,parentSchema:schema11.properties.authenticationType,data:data18};
if(vErrors === null){
vErrors = [err44];
}
else {
vErrors.push(err44);
}
errors++;
}
if(!((data18 === "OAuth") || (data18 === "Basic"))){
const err45 = {instancePath:instancePath+"/authenticationType",schemaPath:"#/properties/authenticationType/enum",keyword:"enum",params:{allowedValues: schema11.properties.authenticationType.enum},message:"must be equal to one of the allowed values",schema:schema11.properties.authenticationType.enum,parentSchema:schema11.properties.authenticationType,data:data18};
if(vErrors === null){
vErrors = [err45];
}
else {
vErrors.push(err45);
}
errors++;
}
}
if(data.useAutodiscover !== undefined){
let data19 = data.useAutodiscover;
if(typeof data19 !== "boolean"){
const err46 = {instancePath:instancePath+"/useAutodiscover",schemaPath:"#/properties/useAutodiscover/type",keyword:"type",params:{type: "boolean"},message:"must be boolean",schema:schema11.properties.useAutodiscover.type,parentSchema:schema11.properties.useAutodiscover,data:data19};
if(vErrors === null){
vErrors = [err46];
}
else {
vErrors.push(err46);
}
errors++;
}
if(!((data19 === true) || (data19 === false))){
const err47 = {instancePath:instancePath+"/useAutodiscover",schemaPath:"#/properties/useAutodiscover/enum",keyword:"enum",params:{allowedValues: schema11.properties.useAutodiscover.enum},message:"must be equal to one of the allowed values",schema:schema11.properties.useAutodiscover.enum,parentSchema:schema11.properties.useAutodiscover,data:data19};
if(vErrors === null){
vErrors = [err47];
}
else {
vErrors.push(err47);
}
errors++;
}
}
if(data.useWellKnownFolder !== undefined){
let data20 = data.useWellKnownFolder;
if(typeof data20 !== "boolean"){
const err48 = {instancePath:instancePath+"/useWellKnownFolder",schemaPath:"#/properties/useWellKnownFolder/type",keyword:"type",params:{type: "boolean"},message:"must be boolean",schema:schema11.properties.useWellKnownFolder.type,parentSchema:schema11.properties.useWellKnownFolder,data:data20};
if(vErrors === null){
vErrors = [err48];
}
else {
vErrors.push(err48);
}
errors++;
}
if(!((data20 === true) || (data20 === false))){
const err49 = {instancePath:instancePath+"/useWellKnownFolder",schemaPath:"#/properties/useWellKnownFolder/enum",keyword:"enum",params:{allowedValues: schema11.properties.useWellKnownFolder.enum},message:"must be equal to one of the allowed values",schema:schema11.properties.useWellKnownFolder.enum,parentSchema:schema11.properties.useWellKnownFolder,data:data20};
if(vErrors === null){
vErrors = [err49];
}
else {
vErrors.push(err49);
}
errors++;
}
}
if(data.useImpersonation !== undefined){
let data21 = data.useImpersonation;
if(typeof data21 !== "boolean"){
const err50 = {instancePath:instancePath+"/useImpersonation",schemaPath:"#/properties/useImpersonation/type",keyword:"type",params:{type: "boolean"},message:"must be boolean",schema:schema11.properties.useImpersonation.type,parentSchema:schema11.properties.useImpersonation,data:data21};
if(vErrors === null){
vErrors = [err50];
}
else {
vErrors.push(err50);
}
errors++;
}
}
if(data.ignoreTrustForSsl !== undefined){
let data22 = data.ignoreTrustForSsl;
if(typeof data22 !== "boolean"){
const err51 = {instancePath:instancePath+"/ignoreTrustForSsl",schemaPath:"#/properties/ignoreTrustForSsl/type",keyword:"type",params:{type: "boolean"},message:"must be boolean",schema:schema11.properties.ignoreTrustForSsl.type,parentSchema:schema11.properties.ignoreTrustForSsl,data:data22};
if(vErrors === null){
vErrors = [err51];
}
else {
vErrors.push(err51);
}
errors++;
}
}
if(data.notice !== undefined){
let data23 = data.notice;
if(data23 && typeof data23 == "object" && !Array.isArray(data23)){
if(data23.testAccountConsent === undefined){
const err52 = {instancePath:instancePath+"/notice",schemaPath:"#/properties/notice/required",keyword:"required",params:{missingProperty: "testAccountConsent"},message:"must have required property '"+"testAccountConsent"+"'",schema:schema11.properties.notice.required,parentSchema:schema11.properties.notice,data:data23};
if(vErrors === null){
vErrors = [err52];
}
else {
vErrors.push(err52);
}
errors++;
}
if(data23.testAccountConsent !== undefined){
let data24 = data23.testAccountConsent;
if(typeof data24 !== "boolean"){
const err53 = {instancePath:instancePath+"/notice/testAccountConsent",schemaPath:"#/properties/notice/properties/testAccountConsent/type",keyword:"type",params:{type: "boolean"},message:"must be boolean",schema:schema11.properties.notice.properties.testAccountConsent.type,parentSchema:schema11.properties.notice.properties.testAccountConsent,data:data24};
if(vErrors === null){
vErrors = [err53];
}
else {
vErrors.push(err53);
}
errors++;
}
}
}
else {
const err54 = {instancePath:instancePath+"/notice",schemaPath:"#/properties/notice/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema11.properties.notice.type,parentSchema:schema11.properties.notice,data:data23};
if(vErrors === null){
vErrors = [err54];
}
else {
vErrors.push(err54);
}
errors++;
}
}
if(data.proofOfWork !== undefined){
let data25 = data.proofOfWork;
if(typeof data25 !== "string"){
const err55 = {instancePath:instancePath+"/proofOfWork",schemaPath:"#/properties/proofOfWork/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.proofOfWork.type,parentSchema:schema11.properties.proofOfWork,data:data25};
if(vErrors === null){
vErrors = [err55];
}
else {
vErrors.push(err55);
}
errors++;
}
}
}
else {
const err56 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema11.type,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err56];
}
else {
vErrors.push(err56);
}
errors++;
}
validate10.errors = vErrors;
return errors === 0;
}

exports["249b33cc"] = validate11;
const schema12 = {"type":"object","properties":{"authenticationType":{"enum":["OAuth"]}},"$id":"249b33cc"};

function validate11(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="249b33cc" */;
let vErrors = null;
let errors = 0;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.authenticationType !== undefined){
let data0 = data.authenticationType;
if(!(data0 === "OAuth")){
const err0 = {instancePath:instancePath+"/authenticationType",schemaPath:"#/properties/authenticationType/enum",keyword:"enum",params:{allowedValues: schema12.properties.authenticationType.enum},message:"must be equal to one of the allowed values",schema:schema12.properties.authenticationType.enum,parentSchema:schema12.properties.authenticationType,data:data0};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
}
else {
const err1 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema12.type,parentSchema:schema12,data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
validate11.errors = vErrors;
return errors === 0;
}

exports["-3625bd4b"] = validate12;
const schema13 = {"type":"object","properties":{"authenticationType":{"enum":["Basic"]}},"$id":"-3625bd4b"};

function validate12(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="-3625bd4b" */;
let vErrors = null;
let errors = 0;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.authenticationType !== undefined){
let data0 = data.authenticationType;
if(!(data0 === "Basic")){
const err0 = {instancePath:instancePath+"/authenticationType",schemaPath:"#/properties/authenticationType/enum",keyword:"enum",params:{allowedValues: schema13.properties.authenticationType.enum},message:"must be equal to one of the allowed values",schema:schema13.properties.authenticationType.enum,parentSchema:schema13.properties.authenticationType,data:data0};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
}
else {
const err1 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema13.type,parentSchema:schema13,data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
validate12.errors = vErrors;
return errors === 0;
}

exports["-16cb1543"] = validate13;
const schema14 = {"type":"object","properties":{"useAutodiscover":{"enum":[false]}},"$id":"-16cb1543"};

function validate13(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="-16cb1543" */;
let vErrors = null;
let errors = 0;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.useAutodiscover !== undefined){
let data0 = data.useAutodiscover;
if(!(data0 === false)){
const err0 = {instancePath:instancePath+"/useAutodiscover",schemaPath:"#/properties/useAutodiscover/enum",keyword:"enum",params:{allowedValues: schema14.properties.useAutodiscover.enum},message:"must be equal to one of the allowed values",schema:schema14.properties.useAutodiscover.enum,parentSchema:schema14.properties.useAutodiscover,data:data0};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
}
else {
const err1 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema14.type,parentSchema:schema14,data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
validate13.errors = vErrors;
return errors === 0;
}

exports["-7ab24ebe"] = validate14;
const schema15 = {"type":"object","properties":{"useAutodiscover":{"enum":[true]}},"$id":"-7ab24ebe"};

function validate14(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="-7ab24ebe" */;
let vErrors = null;
let errors = 0;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.useAutodiscover !== undefined){
let data0 = data.useAutodiscover;
if(!(data0 === true)){
const err0 = {instancePath:instancePath+"/useAutodiscover",schemaPath:"#/properties/useAutodiscover/enum",keyword:"enum",params:{allowedValues: schema15.properties.useAutodiscover.enum},message:"must be equal to one of the allowed values",schema:schema15.properties.useAutodiscover.enum,parentSchema:schema15.properties.useAutodiscover,data:data0};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
}
else {
const err1 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema15.type,parentSchema:schema15,data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
validate14.errors = vErrors;
return errors === 0;
}

exports["-3bff3b4d"] = validate15;
const schema16 = {"type":"object","properties":{"useWellKnownFolder":{"enum":[true]}},"$id":"-3bff3b4d"};

function validate15(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="-3bff3b4d" */;
let vErrors = null;
let errors = 0;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.useWellKnownFolder !== undefined){
let data0 = data.useWellKnownFolder;
if(!(data0 === true)){
const err0 = {instancePath:instancePath+"/useWellKnownFolder",schemaPath:"#/properties/useWellKnownFolder/enum",keyword:"enum",params:{allowedValues: schema16.properties.useWellKnownFolder.enum},message:"must be equal to one of the allowed values",schema:schema16.properties.useWellKnownFolder.enum,parentSchema:schema16.properties.useWellKnownFolder,data:data0};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
}
else {
const err1 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema16.type,parentSchema:schema16,data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
validate15.errors = vErrors;
return errors === 0;
}

exports["-7f1bba94"] = validate16;
const schema17 = {"type":"object","properties":{"useWellKnownFolder":{"enum":[false]}},"$id":"-7f1bba94"};

function validate16(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="-7f1bba94" */;
let vErrors = null;
let errors = 0;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.useWellKnownFolder !== undefined){
let data0 = data.useWellKnownFolder;
if(!(data0 === false)){
const err0 = {instancePath:instancePath+"/useWellKnownFolder",schemaPath:"#/properties/useWellKnownFolder/enum",keyword:"enum",params:{allowedValues: schema17.properties.useWellKnownFolder.enum},message:"must be equal to one of the allowed values",schema:schema17.properties.useWellKnownFolder.enum,parentSchema:schema17.properties.useWellKnownFolder,data:data0};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
}
else {
const err1 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema17.type,parentSchema:schema17,data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
validate16.errors = vErrors;
return errors === 0;
}

exports["5a422c5a"] = validate17;
const schema18 = {"type":"object","properties":{"useImpersonation":{"enum":[true]}},"$id":"5a422c5a"};

function validate17(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="5a422c5a" */;
let vErrors = null;
let errors = 0;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.useImpersonation !== undefined){
let data0 = data.useImpersonation;
if(!(data0 === true)){
const err0 = {instancePath:instancePath+"/useImpersonation",schemaPath:"#/properties/useImpersonation/enum",keyword:"enum",params:{allowedValues: schema18.properties.useImpersonation.enum},message:"must be equal to one of the allowed values",schema:schema18.properties.useImpersonation.enum,parentSchema:schema18.properties.useImpersonation,data:data0};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
}
else {
const err1 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema18.type,parentSchema:schema18,data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
validate17.errors = vErrors;
return errors === 0;
}

exports["-4d302d5b"] = validate18;
const schema19 = {"type":"object","properties":{"useImpersonation":{"enum":[false]}},"$id":"-4d302d5b"};

function validate18(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="-4d302d5b" */;
let vErrors = null;
let errors = 0;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.useImpersonation !== undefined){
let data0 = data.useImpersonation;
if(!(data0 === false)){
const err0 = {instancePath:instancePath+"/useImpersonation",schemaPath:"#/properties/useImpersonation/enum",keyword:"enum",params:{allowedValues: schema19.properties.useImpersonation.enum},message:"must be equal to one of the allowed values",schema:schema19.properties.useImpersonation.enum,parentSchema:schema19.properties.useImpersonation,data:data0};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
}
else {
const err1 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema19.type,parentSchema:schema19,data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
validate18.errors = vErrors;
return errors === 0;
}
